import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AlertComponent } from './alert/alert.component';
import { NumberToWordsDirective } from './number-to-words.directive';
import { ProgressSpinnerComponent } from './progress-spinner/progress-spinner.component';
import { ToastComponent } from './toast/toast.component';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { RemitaComponent } from '../remita/remita.component';
import { LoadingDirective } from './loading.directive';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ModalComponent } from './modal/modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
   providers: [
      ModalComponent,
      ToastComponent,
      AlertComponent,
      ProgressSpinnerComponent,
      NumberToWordsDirective,
      LoadingDirective,
      BreadcrumbComponent,
      RemitaComponent,

   ],
   declarations: [
      ModalComponent,
      ToastComponent,
      AlertComponent,
      ProgressSpinnerComponent,
      NumberToWordsDirective,
      BreadcrumbComponent,
      RemitaComponent,
      LoadingDirective
   ],
   exports: [
      ModalComponent,
      ToastComponent,
      AlertComponent,
      ProgressSpinnerComponent,
      NumberToWordsDirective,
      LoadingDirective,
      BreadcrumbComponent,
      RemitaComponent
   ],
   imports: [
      CommonModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,
      NgbModule,
      NgMultiSelectDropDownModule.forRoot()
   ]
})
export class BootstrapModule { }
